import { createTheme, ThemeOptions } from '@mui/material/styles';
import { components } from 'src/theme/components';
import { typography } from 'src/theme/typography';

import palette from './palette';

const baseTheme: ThemeOptions = {
  palette,
  breakpoints: {
    values: {
      xs: 360,
      sm: 700,
      md: 900,
      lg: 1024,
      xl: 1200,
    },
  },
  typography: { ...typography },
  components: { ...components },
};

export const theme = createTheme(baseTheme);
